import React from 'react';
import { faHandWave } from '@fortawesome/pro-solid-svg-icons/faHandWave';
import { WidgetCard } from '../WidgetCard';

interface Props {
  firstName: string;
  description: string;
  t(param: string): string;
}

export const Greeting = (props: Props): JSX.Element => {
  const { firstName, description, t } = props;
  const date = new Date();
  const hours = date.getHours();
  let greetingType = hours < 12 ? 'morning' : 'afternoon';
  greetingType = hours > 18 ? 'evening' : greetingType;
  const title = `${t(`components.greeting.${greetingType}`)} ${firstName}`;

  return (
    <WidgetCard
      iconName={faHandWave}
      iconClasses='text-honey animate-wave'
      title={title}
      description={description}
    />
  );
};
